export const checkedOptions = [
    { key: '0', value: 'ACTIVE', text: 'Active' },
    { key: '1', value: 'STOPPED', text: 'Stopped' },
    { key: '2', value: 'COMPLETED', text: 'Completed' },
    { key: '4', value: 'TRANSACTED', text: 'Transacted' },
    { key: '5', value: 'RETIRED', text: 'Retired' },
  ]